/**
 * processTemplate模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const processTemplate = {
  // 创建
  createProcessTemplate(params) {
    return $http.post(`${global.API_URL}/sme/processTemplate/create`,params);
  },
  // 编辑
  updateProcessTemplate(params) {
    return $http.post(`${global.API_URL}/sme/processTemplate/update`,params);
  },
  //分页
  pageProcessTemplate(params) {
    return $http.post(`${global.API_URL}/sme/processTemplate/page`,params);
  },
  //删除
  deleteProcessTemplate(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/processTemplate/delete`,param);
  },
  // 流程类型
  processTypes(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/processTemplate/processTypes`,param);
  },
  // 查询流程信息
  selectProcessById(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/processTemplate/selectProcessById`,param);
  },
  //更新状态
  updateState(params) {
    return $http.post(`${global.API_URL}/sme/processTemplate/updateState`,params);
  },
    // 查询审批流名称
  selectListNames(params) {
    return $http.post(`${global.API_URL}/sme/processTemplate/selectListNames`,params);
  },
  // 根据指标查询审批流列表
  listProcessTemplatesByMetricIndex(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/processTemplate/listProcessTemplatesByMetricIndex`,param);
  },
  listProcessTemplatesByMetricIndexAndCompanyId(params) {
    return $http.post(`${global.API_URL}/sme/processTemplate/listProcessTemplatesByMetricIndexAndCompanyId`,params);
  }
}

export default processTemplate;



// WEBPACK FOOTER //
// ./src/api/processTemplate.js